import { useEffect, useState } from 'react';
import isEqual from 'lodash.isequal';
import {
    Box,
    Flex,
    Text
} from '@theme-ui/components';
import { Field } from '~/Forms';
import { Form, Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { getFiltersAsync } from 'features/theme/themeSlice';
import { CompanyTypeOptions, CompanySortByOptions } from 'app/constants';

const fieldWrapStyles = {
    minWidth: '191px',
    width: ['100%','100%','100%','100%','auto'],
    mx: 3
};

const selectStyles = {
    py: '12px'
}

export const SubmitListener = ({ values, initialValues, submitForm, ...props }) => {
    const [lastValues, setLastValues] = useState(values);

    useEffect(() => {
        const valuesEqualLastValues = isEqual(lastValues, values);
        const valuesEqualInitialValues = values === initialValues;

        if (!valuesEqualLastValues) {
            setLastValues(values);
        }

        if (!valuesEqualLastValues && !valuesEqualInitialValues) {
            submitForm();
        }
    }, [
        lastValues,
        values,
        initialValues,
        submitForm
    ]);

    return null;
};

export const Filters = ({ handleSubmit, formRef, ...props }) => {
    const dispatch = useDispatch();
    const theme = useSelector(s => s.theme);
    const [categoryOptions, setCategoryOptions] = useState([]);

    useEffect(() => {
        if (theme.status === 'idle') {
            dispatch(getFiltersAsync());
        }
    }, [dispatch, theme]);

    useEffect(() => {
        if (theme.status === 'attempted') {
            let options = [];
            theme.categories.map(category => options.push({ label: category.name, value: category.uuid }));
            setCategoryOptions(options);
        }
    }, [theme]);

    return (
        <Formik
            enableReinitialize
            innerRef={formRef}
            initialValues={{
                type: '',
                stage: '',
                category: '',
                sortBy: ''
            }}
            onSubmit={handleSubmit}
        >
            {({ values, initialValues, submitForm }) => (
                <Form>
                    <Flex
                        sx={{
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            gap: [3, 3, 3, 3, 0],
                            width: 'fit-content',
                            mx: 'auto',
                        }}
                    >
                        <Flex
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                flex: '1 1 191px',
                            }}
                        >
                            <Box sx={fieldWrapStyles}>
                                <Field
                                    name="search"
                                    label="Search by name or code"
                                    field="input"
                                    groupMb={0}
                                    sx={selectStyles}
                                    placeholder="Search name or code"
                                />
                            </Box>
                        </Flex>

                        <Flex
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                flex: '1 1 191px',
                                minWidth: 'fit-content',
                            }}
                        >
                            <Text as="p" variant="filter_label">
                                or filter by
                            </Text>
                            <Box sx={fieldWrapStyles}>
                                <Field
                                    name="type"
                                    label="Type"
                                    field="select"
                                    options={CompanyTypeOptions}
                                    groupMb={0}
                                    sx={selectStyles}
                                    placeholder="Filter by type"
                                />
                            </Box>
                        </Flex>

                        {categoryOptions.length > 0 && (
                            <Flex
                                sx={{
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flex: '1 1 191px',
                                }}
                            >
                                <Box sx={fieldWrapStyles}>
                                    <Field
                                        name="category"
                                        label="Theme"
                                        field="select"
                                        options={categoryOptions}
                                        groupMb={0}
                                        sx={selectStyles}
                                        placeholder="Filter by theme"
                                    />
                                </Box>
                            </Flex>
                        )}

                        <Flex
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                flex: '1 1 191px',
                            }}
                        >
                            <Box sx={fieldWrapStyles}>
                                <Field
                                    name="sortBy"
                                    label="Sorting By"
                                    field="select"
                                    options={CompanySortByOptions}
                                    groupMb={0}
                                    sx={selectStyles}
                                    placeholder="Sorting by"
                                />
                            </Box>
                        </Flex>
                    </Flex>
                    <SubmitListener values={values} initialValues={initialValues} submitForm={submitForm} />
                </Form>
            )}
        </Formik>
    );
};
